import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Operario/getCambiarEstadoSeleccion`, method: 'POST', body: {list}, token: token})
}
